import { render, staticRenderFns } from "./control2.vue?vue&type=template&id=15b30834&scoped=true&"
import script from "./control2.vue?vue&type=script&lang=js&"
export * from "./control2.vue?vue&type=script&lang=js&"
import style0 from "./control2.vue?vue&type=style&index=0&id=15b30834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b30834",
  null
  
)

export default component.exports